import React from 'react';
import { Link } from 'react-router-dom';
import { ChevronRight, Calendar, Clock, ArrowLeft } from 'lucide-react';
import { Sec, SH, W } from '../components/Shared';
import { BLOG_POSTS } from '../data/websiteData';

export const BlogPage = () => {
  return (
    <div className="af">
      <Sec py={160} bg="var(--grad-hero)">
        <SH eyebrow="Sync Archive" title="Tech Insights" sub="Deep dives into emerging technologies, design systems and club updates." />
        <div className="g3">
          {BLOG_POSTS.map((post, i) => (
            <Link key={post.id} to={`/blog/${post.slug}`} className="card au" style={{ textDecoration: 'none', display: 'flex', flexDirection: 'column' }}>
              <div style={{ height: 220, overflow: 'hidden', position: 'relative' }}>
                <img src={post.img} alt={post.title} style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
                <div style={{ position: 'absolute', top: 16, left: 16 }}>
                  <span className={`badge ${post.bc}`} style={{ background: '#fff', boxShadow: 'var(--shadow-sm)' }}>{post.cat}</span>
                </div>
              </div>
              <div style={{ padding: 24, flex: 1, display: 'flex', flexDirection: 'column' }}>
                <div style={{ display: 'flex', gap: 12, fontSize: 12, color: 'var(--slate-400)', marginBottom: 12, fontWeight: 600 }}>
                  <div style={{ display: 'flex', alignItems: 'center', gap: 4 }}><Calendar size={13} /> {post.date}</div>
                  <div style={{ display: 'flex', alignItems: 'center', gap: 4 }}><Clock size={13} /> {post.read}</div>
                </div>
                <h3 style={{ fontFamily: 'var(--font-display)', fontSize: 20, fontWeight: 700, color: 'var(--on-surface)', lineHeight: 1.3, marginBottom: 12 }}>{post.title}</h3>
                <p style={{ fontSize: 14, color: 'var(--on-surface-variant)', lineHeight: 1.6, marginBottom: 20, flex: 1 }}>{post.excerpt}</p>
                <div style={{ display: 'flex', alignItems: 'center', gap: 8, fontSize: 13, fontWeight: 600, color: 'var(--primary)' }}>
                  Read Transmission <ChevronRight size={14} />
                </div>
              </div>
            </Link>
          ))}
        </div>
      </Sec>
    </div>
  );
};

export const BlogPostPage = ({ post }) => {
  if (!post) return <div style={{ padding: 100, textAlign: 'center' }}>Transmission missing.</div>;
  
  return (
    <div className="af">
      <article>
        <div style={{ position: 'relative', height: '65vh', minHeight: 520, background: 'var(--on-surface)', overflow: 'hidden', display: 'flex', alignItems: 'flex-end' }}>
          <img src={post.img} alt={post.title} style={{ width: '100%', height: '100%', objectFit: 'cover', opacity: 0.6 }} />
          <div style={{ position: 'absolute', inset: 0, background: 'linear-gradient(to bottom, transparent 0%, rgba(0,0,0,.8) 100%)' }} />
          <div style={{ position: 'absolute', bottom: 0, left: 0, right: 0, paddingBottom: 68 }}>
            <W>
              <Link to="/blog" style={{ display: 'inline-flex', alignItems: 'center', gap: 8, color: '#fff', textDecoration: 'none', fontSize: 14, fontWeight: 600, marginBottom: 32, opacity: .7 }} onMouseOver={e => e.currentTarget.style.opacity = 1} onMouseOut={e => e.currentTarget.style.opacity = .7}>
                <ArrowLeft size={16} /> Back to Archive
              </Link>
              <div style={{ maxWidth: 880 }}>
                <div className={`badge ${post.bc}`} style={{ marginBottom: 20 }}>{post.cat}</div>
                <h1 style={{ fontFamily: 'var(--font-display)', fontSize: 'clamp(32px, 5vw, 56px)', fontWeight: 800, color: '#fff', lineHeight: 1.1, letterSpacing: '-0.03em', marginBottom: 32 }}>{post.title}</h1>
                <div style={{ display: 'flex', gap: 24, flexWrap: 'wrap' }}>
                  <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
                    <div style={{ width: 44, height: 44, borderRadius: '50%', overflow: 'hidden', border: '2px solid rgba(255,255,255,.2)' }}>
                      <img src={`https://api.dicebear.com/7.x/avataaars/svg?seed=${post.author.avatar}&backgroundColor=3B82F6`} alt={post.author.name} style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
                    </div>
                    <div>
                      <div style={{ fontSize: 14, fontWeight: 700, color: '#fff' }}>{post.author.name}</div>
                      <div style={{ fontSize: 12, color: 'rgba(255,255,255,.6)' }}>Author</div>
                    </div>
                  </div>
                  <div style={{ padding: '0 1px', background: 'rgba(255,255,255,.1)' }} />
                  <div style={{ display: 'flex', gap: 24 }}>
                    {[['Published', post.date], ['Reading Time', post.read]].map(([l, v]) => (
                      <div key={l}>
                        <div style={{ fontSize: 12, fontWeight: 700, color: 'rgba(255,255,255,.5)', textTransform: 'uppercase', letterSpacing: '.08em', marginBottom: 2 }}>{l}</div>
                        <div style={{ fontSize: 14, fontWeight: 600, color: '#fff' }}>{v}</div>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </W>
          </div>
        </div>

        <Sec py={80}>
          <div className="blog-grid" style={{ display: 'grid', gridTemplateColumns: 'minmax(0, 1fr) 340px', gap: 64 }}>
            <div style={{ fontSize: 18, color: 'var(--on-surface-variant)', lineHeight: 1.8 }}>
              {post.content.map((block, i) => {
                if (block.type === 'p') return <p key={i} style={{ marginBottom: 28 }}>{block.text}</p>;
                if (block.type === 'h2') return <h2 key={i} style={{ fontFamily: 'var(--font-display)', fontSize: 32, fontWeight: 700, color: 'var(--on-surface)', marginTop: 56, marginBottom: 24, letterSpacing: '-.02em' }}>{block.text}</h2>;
                if (block.type === 'h3') return <h3 key={i} style={{ fontFamily: 'var(--font-display)', fontSize: 24, fontWeight: 700, color: 'var(--on-surface)', marginTop: 40, marginBottom: 16 }}>{block.text}</h3>;
                if (block.type === 'blockquote') return <blockquote key={i} style={{ borderLeft: '4px solid var(--primary)', paddingLeft: 32, margin: '48px 0', fontStyle: 'italic', fontSize: 24, color: 'var(--on-surface)', fontWeight: 500 }}>{block.text}</blockquote>;
                if (block.type === 'ul') return <ul key={i} style={{ marginLeft: 24, marginBottom: 28 }}>{block.items.map((item, j) => <li key={j} style={{ marginBottom: 12 }}>{item}</li>)}</ul>;
                return null;
              })}
              
              <div style={{ display: 'flex', gap: 12, marginTop: 64, paddingTop: 48, borderTop: '1px solid var(--slate-100)' }}>
                {post.tags.map((t, j) => <span key={`${t}-${j}`} style={{ fontSize: 13, fontWeight: 600, color: 'var(--slate-500)', background: 'var(--slate-100)', padding: '6px 14px', borderRadius: 100 }}>#{t}</span>)}
              </div>
            </div>

            <aside className="hide-m">
              <div className="card" style={{ padding: 32, position: 'sticky', top: 120 }}>
                <h4 style={{ fontFamily: 'var(--font-display)', fontSize: 18, fontWeight: 700, color: 'var(--on-surface)', marginBottom: 24 }}>About the Team</h4>
                <div style={{ display: 'flex', gap: 16, alignItems: 'center', marginBottom: 20 }}>
                  <img src={`https://api.dicebear.com/7.x/avataaars/svg?seed=${post.author.avatar}&backgroundColor=EFF4FF`} alt={post.author.name} style={{ width: 56, height: 56, borderRadius: 12, background: 'var(--surface-container-low)' }} />
                  <div>
                    <div style={{ fontWeight: 700, color: 'var(--on-surface)' }}>{post.author.name}</div>
                    <div style={{ fontSize: 12, color: 'var(--on-surface-variant)' }}>Core Architecture</div>
                  </div>
                </div>
                <p style={{ fontSize: 14, color: 'var(--on-surface-variant)', lineHeight: 1.6, marginBottom: 24 }}>The ICDITC internal team responsible for research, development and technical documentation across all modules.</p>
                <Link to="/membership" className="btn btn-outline" style={{ width: '100%', justifyContent: 'center' }}>Follow Synapse</Link>
                
                <div style={{ marginTop: 40, paddingTop: 40, borderTop: '1px solid var(--slate-100)' }}>
                  <h4 style={{ fontFamily: 'var(--font-display)', fontSize: 18, fontWeight: 700, color: 'var(--on-surface)', marginBottom: 16 }}>Share Protocol</h4>
                  <div style={{ display: 'flex', gap: 12 }}>
                    {['FB', 'TW', 'IN'].map(s => <button key={s} style={{ width: 44, height: 44, borderRadius: 10, border: '1px solid var(--slate-100)', background: 'transparent', cursor: 'pointer', fontWeight: 700, fontSize: 12, color: 'var(--slate-500)' }}>{s}</button>)}
                  </div>
                </div>
              </div>
            </aside>
          </div>
        </Sec>
      </article>
    </div>
  );
};
